export var svgConfig = {
  trail: {
    x: "-33",
    y: "-33",
    width: "66",
    height: "66",
    xYouAreHere: "-97.5",
    yYouAreHere: "-151",
    widthYouAreHere: "198",
    heightYouAreHere: "198",
    imgView: require("@/assets/images/learning-map/content-view.svg"),
    imgNoView: require("@/assets/images/learning-map/content-no-view.svg"),
    imgHover: require("@/assets/images/learning-map/content-hover.svg"),
  },
  chapter: {
    x: "-50",
    y: "-50",
    width: "96",
    height: "96",
    xYouAreHere: "-128",
    yYouAreHere: "-200",
    widthYouAreHere: "256",
    heightYouAreHere: "256",
    imgView: require("@/assets/images/learning-map/chapter-view.svg"),
    imgNoView: require("@/assets/images/learning-map/chapter-no-view.svg"),
    imgHover: require("@/assets/images/learning-map/chapter-hover.svg"),
  },
};

export var nodePosition = {
  xActual: null,
  xActualTrail: null,
  xEnd: 0,
  xStart: -800,
  yActual: null,
  yEnd: 0,
  yStart: -250,
} as any;

export var nodePositionTeacher = {
  xCurrent: -800,
  xCurrentChapter: 0,
  xEnd: 0,
  xStart: 0,
  yCurrent: 100,
  yEnd: 0,
  yStart: -500,
} as any;

export enum ActionsButtons {
  ADD_OBJECTIVE = "addObjective",
  EDIT_CHAPTER = "editChapter",
  NEXT_CHAPTER = "nextChapter",
  VIEW_OBJECTS = "viewObjectives",
  EDIT_OBJECTIVE = "editObjectives",
  BLACKLIST_OBJECTIVE = "blacklistObjectives",
}

export var menuButtons = [
  {
    title: "Adicionar objetivo",
    titleEN: "Add objective",
    action: ActionsButtons.ADD_OBJECTIVE,
    icon: "md-adsclick",
    type: "CHAPTER",
  },
  {
    title: "Editar capítulo",
    titleEN: "Edit chapter",
    action: ActionsButtons.EDIT_CHAPTER,
    icon: "md-edit",
    type: "CHAPTER",
  },
  {
    title: "Próximo capítulo",
    titleEN: "Next chapter",
    action: ActionsButtons.NEXT_CHAPTER,
    icon: "md-add",
    type: "CHAPTER",
  },
  {
    title: "Visualizar objetos",
    titleEN: "View objects",
    action: ActionsButtons.VIEW_OBJECTS,
    icon: "md-removeredeye",
    type: "LEARNING_OBJECTIVE",
  },
  {
    title: "Editar objetivo",
    titleEN: "Edit objective",
    action: ActionsButtons.EDIT_OBJECTIVE,
    icon: "md-edit",
    type: "LEARNING_OBJECTIVE",
  },
  {
    title: "Adicionar objetivo",
    titleEN: "Add objective",
    action: ActionsButtons.ADD_OBJECTIVE,
    icon: "md-adsclick",
    type: "LEARNING_OBJECTIVE",
  },
  {
    title: "Analisar palavras-chaves",
    titleEN: "Analyze keywords",
    action: ActionsButtons.BLACKLIST_OBJECTIVE,
    icon: "md-managesearch-twotone",
    type: "LEARNING_OBJECTIVE",
  },
];

export var menuButtonsAdmin = [
  {
    title: "Ver objetivo",
    titleEN: "View objective",
    action: ActionsButtons.EDIT_OBJECTIVE,
    icon: "md-removeredeye",
    type: "LEARNING_OBJECTIVE",
  },
  {
    title: "Visualizar objetos",
    titleEN: "View objects",
    action: ActionsButtons.VIEW_OBJECTS,
    icon: "md-removeredeye",
    type: "LEARNING_OBJECTIVE",
  },
  {
    title: "Ver capítulo",
    titleEN: "View chapter",
    action: ActionsButtons.EDIT_CHAPTER,
    icon: "md-removeredeye",
    type: "CHAPTER",
  },
];

export var buttonsStudent = {
  start: {
    title: "start",
    icon: require("@/assets/images/learning-map/student-start1.svg"),
    iconHover: require("@/assets/images/learning-map/student-start.svg"),
    x: -35,
    y: -37,
    width: 70,
    height: 70,
  },
  chapter: {
    title: "chapter",
    icon: require("@/assets/images/learning-map/student-cap.svg"),
    iconHover: require("@/assets/images/learning-map/student-cap.svg"),
    x: -40,
    y: -40,
    width: 80,
    height: 80,
  },
  objective: {
    title: "objective",
    icon: require("@/assets/images/learning-map/student-objective.svg"),
    iconHover: require("@/assets/images/learning-map/student-objective.svg"),
    x: -40,
    y: -40,
    width: 80,
    height: 80,
  },
  pdf: {
    title: "pdf",
    icon: require("@/assets/images/learning-map/student-object-pdf.svg"),
    iconHover: require("@/assets/images/learning-map/student-object-pdf-hover.svg"),
    x: -40,
    y: -40,
    width: 80,
    height: 80,
  },
  image: {
    title: "image",
    icon: require("@/assets/images/learning-map/student-object-image.svg"),
    iconHover: require("@/assets/images/learning-map/student-object-image-hover.svg"),
    x: -40,
    y: -40,
    width: 80,
    height: 80,
  },
  video: {
    title: "video",
    icon: require("@/assets/images/learning-map/student-object-video.svg"),
    iconHover: require("@/assets/images/learning-map/student-object-video-hover.svg"),
    x: -40,
    y: -40,
    width: 80,
    height: 80,
  },
  material: {
    title: "material",
    icon: require("@/assets/images/learning-map/student-object-default.svg"),
    iconHover: require("@/assets/images/learning-map/student-object-default-hover.svg"),
    x: -37,
    y: -37,
    width: 74,
    height: 74,
  },
};
